import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=5c1b6616&scoped=true&"
import script from "./Wrap.vue?vue&type=script&lang=js&"
export * from "./Wrap.vue?vue&type=script&lang=js&"
import style0 from "./Wrap.vue?vue&type=style&index=0&id=5c1b6616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b6616",
  null
  
)

export default component.exports